import {
  FormControl,
  FormLabel,
  Stack,
  Switch,
  SwitchProps,
  useFormControlContext,
} from '@chakra-ui/react';
import * as React from 'react';

export const DeprecatedSubtleSwitch = React.forwardRef<
  HTMLInputElement,
  SwitchProps & { hasBGColor?: boolean }
>(({ children, isDisabled, hasBGColor, ...props }, ref) => {
  const formControlContext = useFormControlContext();
  const areAnyDisabled = formControlContext?.isDisabled || isDisabled;

  return (
    <FormControl isDisabled={areAnyDisabled}>
      <Stack direction={hasBGColor? 'row' : 'row-reverse'} alignItems="center" >
        <FormLabel mb="0" width="full">
          {children}
        </FormLabel>
        <Switch {...props} ref={ref} sx={{
                    "& span.chakra-switch__track": {
                      bg: props.isChecked ? 'primary.500' : 'primary.200',
                    },
                }} />
      </Stack>
    </FormControl>
  );
});

DeprecatedSubtleSwitch.displayName = 'DeprecatedSubtleSwitch';

export const SubtleSwitch = React.forwardRef<
  HTMLInputElement,
  SwitchProps & { stackDirection?: 'row' | 'row-reverse' }  & { hasBGColor?: boolean }
>(({ children, isDisabled, hasBGColor, stackDirection, ...props }, ref) => {
  const formControlContext = useFormControlContext();
  const areAnyDisabled = formControlContext?.isDisabled || isDisabled;

  return (
    <FormControl isDisabled={areAnyDisabled}>
      <Stack
        // direction={stackDirection ? stackDirection : 'row'}
        direction={hasBGColor? 'row' : 'row-reverse'}
        alignItems="center"
        spacing="4"
      >
        <FormLabel mb="0" width="full">
          {children}
        </FormLabel>
        <Switch {...props} ref={ref} />
      </Stack>
    </FormControl>
  );
});

SubtleSwitch.displayName = 'SubtleSwitch';
